export var TaskRequestStatus;
(function (TaskRequestStatus) {
    TaskRequestStatus[TaskRequestStatus["Pending"] = 1] = "Pending";
    TaskRequestStatus[TaskRequestStatus["Approved"] = 2] = "Approved";
    TaskRequestStatus[TaskRequestStatus["ApprovedWithChanges"] = 3] = "ApprovedWithChanges";
    TaskRequestStatus[TaskRequestStatus["Denied"] = 4] = "Denied";
    TaskRequestStatus[TaskRequestStatus["Cancelled"] = 5] = "Cancelled";
})(TaskRequestStatus || (TaskRequestStatus = {}));
